// extracted by mini-css-extract-plugin
export default {"doc":"Documentation_doc__zINFq","dark":"Documentation_dark__ijCk-"};